/*
 * @Author: DESKTOP-NOLIOCQ\ocamar changdi.zhao@ocamar.com
 * @Date: 2023-11-09 13:48:46
 * @LastEditors: DESKTOP-NOLIOCQ\ocamar changdi.zhao@ocamar.com
 * @LastEditTime: 2023-11-16 17:28:34
 * @FilePath: \difuSite\src\router.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import Router from 'vue-router'
import { _isMobile } from '@/utils'
console.log('_isMobile()', _isMobile())
Vue.use(Router)
const baseUrl = _isMobile() ? 'mobile/' : ''
const isHide = !_isMobile()
// Promise.resolve(require(`@/views/${view}`).default)
export const routes = [
  {
    path: '/',
    name: 'Layout',
    redirect: '/',
    component: () =>Promise.resolve(require(`@/${baseUrl}layout`).default),
    children: [
      // {
      //   path: '/',
      //   name: 'HomeAll',
      //   redirect: '/',
      //   hiddenChild: true,
      //   component: () => Promise.resolve(require(`@/${baseUrl}views/homeAll/index`).default),
      //   meta: { title: '首页' },
      //   children: [
      //     {
      //       path: '/',
      //       name: 'Home',
      //       hidden: true,
      //       component: () => Promise.resolve(require(`@/${baseUrl}views/homeAll/Home`).default),
      //       meta: { title: '', activeMenu: '/' }
      //     },
          
      //   ]
      // },
        {
          path: '/',
          name: 'Home',
          hidden: false,
          component: () => Promise.resolve(require(`@/${baseUrl}views/homeAll/Home`).default),
          meta: {  title: '首页', activeMenu: '/' }
        },
          
      
      {
        path: '/solution',
        name: 'solution',
        redirect: '/',
        component: () => Promise.resolve(require(`@/${baseUrl}views/solution`).default),
        meta: { title: '解决方案' },
        children:[
          {
            path: '/wifiNetwork',
            name: 'WifiNetwork',
            hidden: false,
            component: () => Promise.resolve(require(`@/views/details/wifiNetwork`).default),
            meta: { title: 'WIFI无线网络解决方案', activeMenu: '/' }
          },
          
          
         
          // {
          //   path: '/transfuse',
          //   name: 'Transfuse',
          //   hidden: false,
          //   component: () => Promise.resolve(require(`@/views/details/transfuse`).default),
          //   meta: { title: '输液监控系统', activeMenu: '/' }
          // },
          // {
          //   path: '/tiwen',
          //   name: 'Tiwen',
          //   hidden: false,
          //   component: () => Promise.resolve(require(`@/views/details/tiwen`).default),
          //   meta: { title: '无线体温采集系统', activeMenu: '/' }
          // },
          {
            path: '/baby',
            name: 'Baby',
            hidden: false,
            component: () => Promise.resolve(require(`@/views/details/baby`).default),
            meta: { title: '婴儿防盗系统', activeMenu: '/' }
          },
          {
            path: '/assets',
            name: 'Assets',
            hidden: false,
            component: () => Promise.resolve(require(`@/views/details/assets`).default),
            meta: { title: '资产定位系统', activeMenu: '/' }
          },
          {
            path: '/belost',
            name: 'beLost',
            hidden: false,
            component: () => Promise.resolve(require(`@/views/details/beLost`).default),
            meta: { title: '特殊患者防走失系统', activeMenu: '/' }
          },
          {
            path: '/ward',
            name: 'Ward',
            hidden: false,
            component: () => Promise.resolve(require(`@/views/details/ward`).default),
            meta: { title: '智慧病房交互系统', activeMenu: '/' }
          },
          {
            path: '/nurse',
            name: 'Nurse',
            hidden: false,
            component: () => Promise.resolve(require(`@/views/details/nurse`).default),
            meta: { title: '移动护理信息系统', activeMenu: '/' }
          },
          {
            path: '/coldChain',
            name: 'coldChain',
            hidden: false,
            component: () => Promise.resolve(require(`@/views/details/coldChain`).default),
            meta: { title: '院内冷链管理系统', activeMenu: '/' }
          },
          {
            path: '/device',
            name: 'Device',
            hidden: false,
            component: () => Promise.resolve(require(`@/views/details/device`).default),
            meta: { title: '设备能效管理系统', activeMenu: '/' }
          },
          {
            path: '/medicalWaste',
            name: 'medicalWaste',
            hidden: false,
            component: () => Promise.resolve(require(`@/views/details/medicalWaste`).default),
            meta: { title: '医废管理系统', activeMenu: '/' }
          },
          {
            path: '/medicalFabric',
            name: 'medicalFabric',
            hidden: false,
            component: () => Promise.resolve(require(`@/views/details/medicalFabric`).default),
            meta: { title: '医疗织物RFID洗涤管理系统', activeMenu: '/' }
          },
          {
            path: '/medicalRobots',
            name: 'medicalRobots',
            hidden: false,
            component: () => Promise.resolve(require(`@/views/details/medicalRobots`).default),
            meta: { title: '医疗机器人', activeMenu: '/' }
          },
          
          
        ]
      },
      {
        path: '/serve',
        name: 'Serve',
        component: () => Promise.resolve(require(`@/${baseUrl}views/serve/index`).default),
        meta: { title: '平台服务' }
      },
      {
        path: '/news',
        name: 'news',
        component: () => Promise.resolve(require(`@/views/news`).default),
        meta: { title: '新闻资讯' },
      },
      {
        path: '/newsDetails',
        name: 'newsDetails',
        hidden: true,
        component: () => Promise.resolve(require(`@/views/news/details`).default),
        meta: { title: '新闻详情' },
      },
      // {
      //   path: '/cooperation',
      //   name: 'Cooperation',
      //   component: () => Promise.resolve(require(`@/${baseUrl}views/cooperation`).default),
      //   meta: { title: '合作客户' }
      // },
      {
        path: '/aboutUs',
        redirect: '/contactUs',
        component: () => Promise.resolve(require(`@/views/homeAll/index`).default),
        meta: { title: '关于迪孚' },
        children: [
          {
            path: '/aboutUs',
            name: 'aboutUs',
            component: () => Promise.resolve(require(`@/views/about`).default),
            meta: { title: '关于迪孚' }
          },
          {
            path: '/contactUs',
            name: 'ContactUs',
            component: () => Promise.resolve(require(`@/${baseUrl}views/contactUs`).default),
            meta: { title: '联系我们' }
          },
          
        ]
      },
      
    ]
  }
]

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes
})
